module.exports = __webpack_public_path__ + "static/media/image_49.28e7792c.png";